module.exports = __webpack_public_path__ + "3257a1e741ca7f87c4604fff1ef663f1.woff2";